// trap focus
export function trapFocus(element) {
  const KEYCODE_TAB = 9;
  let focusableEls = element.querySelectorAll(`
    a[href]:not([disabled]),
    button:not([disabled]),
    textarea:not([disabled]),
    input[type="text"]:not([disabled]),
    input[type="radio"]:not([disabled]),
    input[type="checkbox"]:not([disabled]),
    select:not([disabled])
  `);

  // Only proceed if there are focusable elements
  if (focusableEls.length === 0) {
    return;
  }

  let firstFocusableEl = focusableEls[0];
  let lastFocusableEl = focusableEls[focusableEls.length - 1];

  // set focus to first element
  firstFocusableEl.focus();

  // Create a specific keydown handler for this element
  const handleKeydown = function (e) {
    let isTabPressed = e.key === "Tab" || e.keyCode === KEYCODE_TAB;

    if (!isTabPressed) {
      return;
    }

    if (e.shiftKey) {
      /* shift + tab */ if (document.activeElement === firstFocusableEl) {
        lastFocusableEl.focus();
        e.preventDefault();
      }
    } /* tab */ else {
      if (document.activeElement === lastFocusableEl) {
        firstFocusableEl.focus();
        e.preventDefault();
      }
    }
  };

  // Add the event listener to the specific element
  element.addEventListener("keydown", handleKeydown);

  // Return a cleanup function
  return function () {
    element.removeEventListener("keydown", handleKeydown);
  };
}
